import { ProductRatePlansEnscape } from '../ratePlan';
import { isUniversityRatePlan } from './isUniversityRatePlan';

export interface LicenseConfig {
  productRatePlan_FloatingLicense: ProductRatePlansEnscape;
}

export interface LicenseRatePlan {
  ProductCode__c?: string | null;
  productRatePlanId: string;
}

export interface LicenseSubscription {
  ratePlans: LicenseRatePlan[];
  messages?: {
    type: string;
  }[];
}

export interface License {
  subscriptions: LicenseSubscription[];
}

export const makeLicenseCapacities = (license: License, config: LicenseConfig) => {
  const isUniversity = () =>
    license.subscriptions.some((subscription) => subscription.ratePlans.some(isUniversityRatePlan));

  const isFloating = () =>
    license.subscriptions.some((subscription) =>
      subscription.ratePlans.some(
        (ratePlan) => config.productRatePlan_FloatingLicense.id === ratePlan.productRatePlanId,
      ),
    );

  const hasSubscriptionWithCancel = () =>
    license.subscriptions.some((subscription) =>
      subscription.messages?.some(({ type }) => type === 'cancel'),
    );

  const canAddSubscription = () => (isFloating() || isUniversity()) && !hasSubscriptionWithCancel();

  const canDisplayUsage = () => isFloating();

  return {
    canAddSubscription,
    canDisplayUsage,
  };
};

export type LicenseCapacities = ReturnType<typeof makeLicenseCapacities>;
